import 'styles/templates/models.scss'

import 'scripts/vue/main'

import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal)

window.PSTheme.Vue.Models = new Vue({
  name: 'ModelsWrapper',
  components: {
    'models': require('../vue/templates/Models.vue').default
  }
}).$mount('.models')
